export default __webpack_public_path__ + "static/media/indicator-active.31cf12ef.svg";